import { Injectable } from '@angular/core';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';
import { AmberApi } from 'app/core/models/api-helpers';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { URLSearchParams } from '@angular/http'

@Injectable()
export class BuyerToSellerService {

  private termsAndConditions$: Observable<any>;
  private signatories$: Observable<any[]>;
  private resetSignatories$ = new Subject<void>();
  private resetTermsAndConditions$ = new Subject<void>();

  getEmployeeData(userId: string): Observable<any> {
    let url = this.configService.get('server').url + `${this.configService.get('endpoints').agora.employees.getByEmail.api}?emailId=${encodeURIComponent(userId)}`;
    return this.requestService.get(url, {}).extract(AmberApi.Data);
  }

  checkOngoingRequests(): Observable<any[]> {
    const url =
      this.configService.get('server').url +
      this.configService.get('endpoints').phoenix2.buyerToSeller.ongoingRequests.api;
    return this.requestService.get(url).extract(AmberApi.Data);
  }

  agreeOnTermsAndConditionsAuthorized(): Observable<any> {
    const url = this.configService.get('server').url + this.configService.get('endpoints').phoenix2.buyerToSeller.authorizedAgree.api;
    return this.requestService.post(url, {}).extract(AmberApi.Data);
  }

  agreeOnTermsAndConditions(id: string): Observable<any> {
    const url = this.configService.get('server').url + this.configService.get('endpoints').phoenix2.buyerToSeller.agree.api + '/' + id;
    return this.requestService.post(url, {}).extract(AmberApi.Data);
  }

  getTermsAndConditions(): Observable<any> {
    if (!this.termsAndConditions$) {
      const url = this.configService.get('server').url + this.configService.get('endpoints').phoenix2.buyerToSeller.termsAndConditions.api;
      this.termsAndConditions$ = this.requestService.get(url).extract(AmberApi.Data)
        .takeUntil(this.resetTermsAndConditions$)
        .shareReplay(1);
    }
    return this.termsAndConditions$;
  }

  listSignatories(): Observable<any[]> {
    if (!this.signatories$) {
      const url =
        this.configService.get('server').url +
        this.configService.get('endpoints').agora.employees.authorizedSignatoryListJWT.api;
      this.signatories$ = this.requestService.get(url).extract(AmberApi.Data).takeUntil(this.resetSignatories$).shareReplay(1);
    }
    return this.signatories$;
  }

  notify(signatory: any): Observable<any> {
    const url =
      this.configService.get('server').url +
      this.configService.get('endpoints').phoenix2.buyerToSeller.notifySignatory.api;
    return this.requestService.post(url, signatory);
  }

  getSignedRequests(id: string): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').phoenix2.buyerToSeller.getSignedRequests.api +
      '/' +
      id;
    return this.requestService.get(url).extract(AmberApi.Data);
  }

  getLogo(): string {
    return this.configService.get('aws').downloadUrl + this.configService.get('images').newColorEdcastLogo;
  }

  kill() {
    this.resetSignatories$.next();
    this.resetTermsAndConditions$.next();
    this.signatories$ = null;
    this.termsAndConditions$ = null;
  }

  formatDate(date: string): string {
    if (!date)
      return '';
    let notificationDate = new Date(date);
    return ` ${notificationDate.getDate()}-${notificationDate.getMonth()}-${notificationDate.getFullYear()}`
      + ` at ${this.formatTime(notificationDate)}`;
  }

  private leadingZero(num) {
    return `0${num}`.slice(-2);
  }

  private formatTime(date): string {
    return [date.getHours(), date.getMinutes(), date.getSeconds()]
      .map(this.leadingZero)
      .join(':');
  }

  constructor(
    private configService: ConfigService,
    private requestService: RequestService
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/core/components/buyer-to-seller-wrapper/buyer-to-seller/buyer-to-seller.service.ts